import { CA_LANGUAGE_ENUMS } from '@/lib/constants/domain-schema'
import { toTitleCaseWithoutUnderscores } from '@/lib/helpers/string'

export const caLanguageEnumsRef = language => {
  return CA_LANGUAGE_ENUMS[language]
}

export const getEnumOptions = (
  agreementsAndSchema,
  tld,
  field,
  stringTransformFunc = toTitleCaseWithoutUnderscores
) => {
  const enums = agreementsAndSchema[tld].schema.properties[field].enum

  const options = enums.map(item => {
    return { handle: item, label: stringTransformFunc(item) }
  })

  return options
}

export const getUsEntityTypeEnumOptions = (intentType, usEntityTypeEnums) => {
  const options = usEntityTypeEnums[intentType].map(item => {
    return { handle: item, label: toTitleCaseWithoutUnderscores(item) }
  })

  return options
}
